import classnames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { Button, Message } from '@meitu/saas-ui';
import IconFont from '@meitu/xdesign-icon-font';
import { isEditTagMaterial } from '@/hooks/fetch-template/editor-mode';
import { editor } from '@/instance';
import { useTemplateModel } from '@/store/models/template-model';
import { useTextMarkModel } from '@/store/models/text-mark-model';
import { isInternalDesignerMode } from '@/utils/auth';
import { getQueryParam } from '@/utils/query';
import SaveFail from './save-fail';
import SaveSuccess from './save-success';
import saveTemplate from './use-save-template';

const SaveBtn = () => {
    const [disableOperate, setDisableOperate] = useState(false);

    // 是否存草稿
    const draft = useRef(false);
    const [showSaveSuccess, setShowSaveSuccess] = useState(false);
    const [showSaveFail, setShowSaveFail] = useState(false);

    const templateName = useTemplateModel((state) => state.templateName);
    const resolution = useTemplateModel((state) => state.resolution);
    const canvasType = useTemplateModel((state) => state.canvasType);
    const subject = useTemplateModel((state) => state.subject);
    const initFromRecord = useTemplateModel((state) => state.initFromRecord);
    const originMaterialId = useTemplateModel((state) => state.originMaterialId);
    const extraInfo = useTemplateModel((state) => state.extraInfo);
    const psdFileUrl = useTemplateModel((state) => state.psdFileUrl);
    const useWatermark = useTemplateModel((state) => state.useWatermark);
    const initTemplateInfo = useTemplateModel((state) => state.initTemplateInfo);
    const markConfig = useTextMarkModel((state) => state.markConfig);
    const textArtConfig = useTextMarkModel((state) => state.textArtConfig);

    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        draft.current = getQueryParam('draft') === '1';
    }, []);

    useEffect(() => {
        // 监听editor状态
        editor.onState(({ disableOperate, disablePick, isBaseOperate }) => {
            setDisableOperate((disableOperate || disablePick) && !isBaseOperate);
        });
    }, []);

    const handlerSave = async (showModal = true, save = true, back = false, successMsg = '保存成功') => {
        try {
            await saveTemplate(
                editor,
                templateName,
                resolution,
                canvasType,
                subject,
                initFromRecord,
                originMaterialId,
                extraInfo,
                psdFileUrl || '',
                useWatermark,
                setLoading,
                setShowSaveFail,
                setShowSaveSuccess,
                initTemplateInfo,
                showModal,
                save,
                back,
                successMsg,
                editor.services.font.getFonts(),
                markConfig,
                textArtConfig,
            );
        } catch (e: any) {
            Message.error(e);
        }
    };

    const handlerSaveRef = useRef(handlerSave);
    handlerSaveRef.current = handlerSave;

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (!(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== 's') return;
            event.preventDefault();
            void handlerSaveRef.current(!draft.current, !draft.current, false, '保存成功');
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    if (isEditTagMaterial()) {
        return null;
    }

    return (
        <div
            className={classnames('p-header__save-btn', {
                'p-header__redo-btn--disable': disableOperate,
            })}
            style={{ marginRight: '10px' }}
        >
            {showSaveSuccess && !isInternalDesignerMode() ? (
                <SaveSuccess
                    closeModel={() => {
                        setShowSaveSuccess(false);
                    }}
                />
            ) : null}
            {showSaveFail ? (
                <SaveFail
                    closeModel={() => {
                        setShowSaveFail(false);
                    }}
                />
            ) : null}

            <Button
                type="primary"
                data-blue
                disabled={disableOperate}
                onClick={() => {
                    handlerSave(
                        !draft.current,
                        !draft.current,
                        draft.current,
                        draft.current ? '保存成功，请到任务详情里【提交审核】' : '保存成功',
                    );
                }}
                icon={<IconFont name="CloudSyn" fontSize={20} />}
            >
                保存
            </Button>
        </div>
    );
};

export default React.memo(SaveBtn);
